import axios from 'axios'
import { mapGetters, mapActions } from 'vuex'
export default {
    computed: {
        ...mapGetters({
            sections: 'AddressFormStore/GetSections',
            address: 'AddressFormStore/GetAddress',
            addressErrors: 'AddressFormStore/GetAddressErrors',
            autocomplete: 'AddressFormStore/GetAutocomplete'
        })
    },
    methods: {
        ...mapActions({
            clearAddress: 'AddressFormStore/ClearAddress',
            clearAddressErrors: 'AddressFormStore/ClearAddressErrors'
        }),

        expandManualAddress () {
            if (this.address.countryCode) {
                if (this.address.countryCode === 'GB') this.sections.expandManualUkAddress = true
                if (this.address.countryCode === 'US') this.sections.expandManualUsAddress = true
                if (this.address.countryCode === 'QA') this.sections.expandManualQAAddress = true
                if (this.address.countryCode === 'AE') this.sections.expandManualAEAddress = true
            }
        },

        async chooseCountry () {
            this.clearAddress()
            this.clearAddressErrors()

            this.sections.expandManualUkAddress = false
            this.sections.expandManualUsAddress = false
            this.sections.expandManualQAAddress = false
            this.sections.expandManualAEAddress = false

            this.form.organisationDefaultPhoneCountryCode = null

            switch (this.address.countryCode) {
                case 'GB':
                    this.form.organisationDefaultPhoneCountryCode = '+44'
                    break
                case 'US':
                    this.form.organisationDefaultPhoneCountryCode = '+1'
                    break
                case 'QA':
                    this.form.organisationDefaultPhoneCountryCode = '+974'
                    break
                case 'AE':
                    this.form.organisationDefaultPhoneCountryCode = '+971'
                    break
                case 'SG':
                    this.form.organisationDefaultPhoneCountryCode = '+65'
                    break
            }
        },

        async findAddress () {
            if (this.autocomplete.addressQueryString && this.autocomplete.addressQueryString.trim()) {
                if (this.autocomplete.addressTimeout) clearTimeout(this.autocomplete.addressTimeout)

                this.autocomplete.addressTimeout = setTimeout(async () => {
                    const response = await axios.get(`https://api.addressy.com/Capture/Interactive/Find/v1.10/json3.ws?Key=${process.env.VUE_APP_GET_ADDRESS_API_KEY}&Text=${this.autocomplete.addressQueryString}&IsMiddleware=True&Countries=${this.address.countryCode}&Limit=50`)
                    this.autocomplete.autocompleteSuggestions = response.data.Items.filter(x => x.Type === 'Address')
                }, 300)
            } else {
                this.autocomplete.autocompleteSuggestions = []
            }
        },

        async chooseSuggestion (id) {
            this.clearAddress()
            this.clearAddressErrors()

            const response = await axios.get(`https://api.addressy.com/Capture/Interactive/Retrieve/v1.20/json3.ws?Key=${process.env.VUE_APP_GET_ADDRESS_API_KEY}&Id=${id}`)

            if (response.data && response.data.Items && response.data.Items.length > 0) {
                this.autocomplete.autocompleteSuggestions = []
                this.autocomplete.addressQueryString = null
                this.address.language = response.data.Items[0].Language
                this.address.buildingNumber = response.data.Items[0].BuildingNumber
                this.address.buildingName = response.data.Items[0].BuildingName
                this.address.street = response.data.Items[0].Street
                this.address.line = response.data.Items[0].Line1
                this.address.line2 = response.data.Items[0].Line2
                this.address.line3 = response.data.Items[0].Line3
                this.address.city = response.data.Items[0].City
                this.address.district = response.data.Items[0].District
                this.address.provinceName = response.data.Items[0].ProvinceName
                this.address.provinceCode = response.data.Items[0].ProvinceCode
                this.address.postalCode = response.data.Items[0].PostalCode
                this.address.country = response.data.Items[0].CountryName
                this.address.countryCode = response.data.Items[0].CountryIso2
                this.address.countryIso3Code = response.data.Items[0].CountryIso3

                this.expandManualAddress()

                const geoResponse = await axios.get(`https://api.addressy.com/Geocoding/International/Geocode/v1.10/json3.ws?Key=${process.env.VUE_APP_GET_ADDRESS_GEOCODE_API_KEY}&Country=${this.address.countryCode}&Location=${this.address.line} ${this.address.city}`)
                if (geoResponse.data && geoResponse.data.Items && geoResponse.data.Items.length > 0) {
                    this.address.latitude = geoResponse.data.Items[0].Latitude
                    this.address.longitude = geoResponse.data.Items[0].Longitude
                }
            }
        },

        checkAddress() {
            this.clearAddressErrors()

            if (!this.address.line) {
                this.addressErrors.line = ['The address 1 field is required']
            }

            if (this.address.countryCode === 'GB' || this.address.countryCode === 'US' || this.address.countryCode === 'SG') {
                if (!this.address.postalCode) {
                    this.addressErrors.postalCode = ['The postal / zip code field is required']
                }
            }

            if (this.address.countryCode === 'US') {
                if (!this.address.provinceName) {
                    this.addressErrors.provinceName = ['The state field is required']
                }
            }

            if (!this.address.city) {
                this.addressErrors.city = ['The city field is required']
            }

            if (!this.address.country) {
                this.addressErrors.country = ['The country field is required']
            }

            if (!this.address.countryCode) {
                this.addressErrors.countryCode = ['The country code field is required']
            }
        }
    }
}